// Prescriptions live in the shared server/client catalogue.
import { CURATED_PLANS, type CuratedPlan, type FitnessGoal, type FitnessLevel } from '../../supabase/functions/_shared/fitnessCuratedPlans';
export { CURATED_PLANS };
export type { CuratedPlan, FitnessGoal, FitnessLevel, PlanDay, PlanExercise } from '../../supabase/functions/_shared/fitnessCuratedPlans';
const BEGINNER_HYPERTROPHY = CURATED_PLANS[1];

/** Find the best matching plan based on user preferences */
export function recommendPlan(
  goal: FitnessGoal,
  level: FitnessLevel,
  daysPerWeek: number,
): CuratedPlan {
  // Try exact match first
  const exact = CURATED_PLANS.find(
    (p) => p.goal === goal && p.level === level && p.daysPerWeek <= daysPerWeek,
  );
  if (exact) return exact;

  // Match goal + level
  const goalLevel = CURATED_PLANS.find(
    (p) => p.goal === goal && p.level === level,
  );
  if (goalLevel) return goalLevel;

  // Match goal only
  const goalOnly = CURATED_PLANS.find((p) => p.goal === goal);
  if (goalOnly) return goalOnly;

  // Default to beginner hypertrophy
  return BEGINNER_HYPERTROPHY;
}
